export const defaultProps = {
    link: "#",
    description: false,
    data: []
};
